var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "\n    v-input\n    k-filter-v-input k-filter-v-date\n    v-text-field v-text-field--box v-text-field--enclosed\n    v-input--hide-details\n    theme--light\n  "
    },
    [
      _c("div", { staticClass: "v-input__control" }, [
        _c("div", { staticClass: "v-input__slot" }, [
          _c(
            "div",
            { staticClass: "v-text-field__slot" },
            [
              _c(
                "label",
                {
                  staticClass: "theme--light v-label v-label--active",
                  attrs: { "aria-hidden": "true" }
                },
                [_vm._v(_vm._s(_vm.filterLabel))]
              ),
              _vm._v(" "),
              _vm.isDateTime
                ? _c("date-time-picker", {
                    ref: "dateInput",
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabledInput,
                      show: _vm.showDatetimePicker,
                      required: !_vm.disabledInput ? true : false
                    },
                    on: {
                      change: _vm.handleDateChange,
                      focus: function($event) {
                        $event.stopPropagation()
                      },
                      iconclick: _vm.handleDatetimeIconClick
                    }
                  })
                : _c("date-picker", {
                    ref: "dateInput",
                    staticClass: "visible",
                    attrs: {
                      value: _vm.value,
                      disabled: _vm.disabledInput,
                      required: !_vm.disabledInput ? true : false
                    },
                    on: {
                      change: _vm.handleDateChange,
                      focus: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }